import { useOnceExecute } from '@r1-frontend/shared/hooks/useOnceExecute';

import { useIntersectionObserver } from '~/src/helpers/hooks/useIntersectionObserver';

/**
 * Разово выполняет переданный коллбэк в том случае, когда элемент появляется в viewport
 * @param callback - коллбэк, который необходимо выполнить
 */
export const useElementVisibility = (callback: () => void): ReturnType<typeof useIntersectionObserver> => {
    const executeOnce = useOnceExecute(() => {
        callback();
    });

    const onElementVisible = ([{ isIntersecting }]: IntersectionObserverEntry[]) => {
        if (isIntersecting) {
            executeOnce();
        }
    };

    return useIntersectionObserver(onElementVisible, { root: null, rootMargin: '', threshold: 1 });
};
